/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { APP_COLORS } from "../../constants/styles";
import { removeAllTagsFromBody } from "../../utils/articleHelpers";
import { useGetLink } from "../../utils/useOpenLink";
import useCustomTranslation from "../../utils/useCustomTranslation";

import ArrowSvg from "../../assets/ArrowSvg";
import "./FeatureTilesShaded.css";
import { WindowContext } from "../WindowResize/resize";

function FeatureTilesShaded({
    heading,
    body,
    number_of_rows,
    contents: contentsArray = [],
    block_source,
    colors: colorObj,
}) {
    const [contentItems, setContentItems] = useState([]);
    const { getLink } = useGetLink();
    const { t } = useCustomTranslation();
    const { isMobile } = useContext(WindowContext);

    useEffect(() => {
        const contentArr = contentsArray.map((item, index) => {
            if (item.content_source === "Content") {
                return {
                    title: item.heading,
                    body: removeAllTagsFromBody(item.body),
                    subtitle: item.heading,
                    image_src: item.content_image?.src,
                    image_alt: item.content_image?.alt,
                    className:
                        index === 0
                            ? "primaryTile md:row-span-2 lg:row-span-2 md:col-span-2 lg:col-span-2"
                            : "",
                    href: item.content_reference,
                    type: item.type,
                };
            }
            return null;
        });

        setContentItems([...contentArr]);
    }, [contentsArray, block_source]);

    return (
        <div className="container" style={APP_COLORS(colorObj)}>
            <div className="featureTilesShaded py-30" data-aos="fade-up">
                {heading && body && (
                    <>
                        <h2 className="text-primary_color text-center font-medium text-4xl my-5">
                            {heading}
                        </h2>
                        <div className="componentBody text-accent_color1 text-center font-normal text-[18px] lg:text-[28px] mb-6 lg:mb-7">
                            {removeAllTagsFromBody(body)}
                        </div>
                        <div className="w-[132px] h-[1px] bg-accent_color1 opacity-50 mx-auto mt-4 mb-9 lg:mb-[60px]" />
                    </>
                )}

                <div className="grid grid-cols-1 md:grid-cols-4 md:grid-rows-2 gap-4">
                    {contentItems.map((item, index) => (
                        <div key={index} className={`${item.className} overflow-hidden relative`}>
                            <Link
                                to={getLink(item.href, item.type)}
                                className="group relative aspect-square overflow-hidden text-accent_color4 cursor-pointer link_color"
                            >
                                {number_of_rows === 2 ? (
                                    <div className="relative w-full h-full border border-solid border-accent_color3 rounded-[15px] overflow-hidden">
                                        {index === 0 && !isMobile ? (
                                            <div className="tile-primary-content">
                                                <h4 className="text-primary_color">
                                                    {item.body.length > 50
                                                        ? item.body.slice(0, 50) + " ..."
                                                        : item.body}
                                                </h4>
                                                <h2 className="text-accent_color1">{item.title}</h2>
                                                <Link
                                                    to={getLink(item.href, item.type)}
                                                    className="learnMoreBtn text-accent_color3"
                                                >
                                                    {t("btnText.learnMore")}
                                                </Link>
                                            </div>
                                        ) : (
                                            <div className="tile-secondary-content">
                                                <h4 className="text-primary_color">
                                                    {item.body.length > 50
                                                        ? item.body.slice(0, 50) + " ..."
                                                        : item.body}
                                                </h4>
                                                <h2 className="text-accent_color1">{item.title}</h2>
                                                <Link
                                                    to={getLink(item.href, item.type)}
                                                    className="learnMoreBtn text-accent_color3"
                                                >
                                                    {t("btnText.learnMore")}
                                                </Link>
                                            </div>
                                        )}
                                        <div className="tile-image-wrapper">
                                            <img
                                                src={item.image_src}
                                                alt={item.image_alt}
                                                className="w-full h-full object-cover"
                                            />
                                        </div>
                                    </div>
                                ) : (
                                    <div className="relative w-full h-full rounded-[15px] overflow-hidden">
                                        <div className="tile-overlay-bottom bg-primary-transparent">
                                            <div className="tile-text-block">
                                                <h4>
                                                    {item.body.length > (index === 0 ? 60 : 50)
                                                        ? item.body.slice(
                                                              0,
                                                              index === 0 ? 60 : 50,
                                                          ) + " ..."
                                                        : item.body}
                                                </h4>
                                                <h2>{item.title}</h2>
                                            </div>
                                            <Link
                                                to={getLink(item.href, item.type)}
                                                className="text-accent_color4 hover:text-accent_color4 flex items-center h-full transition-transform duration-500 group-hover:-rotate-45 cursor-pointer"
                                            >
                                                <ArrowSvg className="text-accent_color4" />
                                            </Link>
                                        </div>
                                        <div className="tile-secondary-image-wrapper">
                                            <img
                                                src={item.image_src}
                                                alt={item.image_alt}
                                                className="w-full h-full object-cover"
                                            />
                                        </div>
                                    </div>
                                )}
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default FeatureTilesShaded;
